module.exports = __webpack_public_path__ + "static/media/checkbox-icon.359c191a.svg";